import { useMemo, useState } from 'react';
import { Button } from '@antimatterhq/ui/components/button';
import { Icon } from '@antimatterhq/ui/components/icon';
import { Input } from '@antimatterhq/ui/components/input';
import { DatasourceUpgradeStringFieldDiff } from '@/lib/datasource/upgrade/datasourceUpgrade.types';

export const DatasourceUpgradeDiffTextbox = ({
  diff,
  onApply,
  isApplying,
}: {
  diff: DatasourceUpgradeStringFieldDiff;
  onApply: (value: string) => void;
  isApplying?: boolean;
}) => {
  const [current, setCurrent] = useState(diff.upgradeValue ?? '');

  const applied = useMemo(() => {
    return diff.upgradeValue === current && diff.status === 'confirmed';
  }, [diff.upgradeValue, current, diff.status]);

  return (
    <div
      className="flex w-full flex-col"
      data-testid={`datasource-upgrade-diff-textbox-root-${diff.title}`}
    >
      <div className="relative">
        <div className="flex gap-2">
          <div className="flex-1">
            <Input
              value={diff.currentValue}
              disabled
              className="mx-auto max-w-[500px]"
              data-testid="datasource-upgrade-diff-textbox-current-value"
            />
          </div>
          <div className="flex-1">
            <Input
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              className="mx-auto max-w-[500px]"
              data-testid="datasource-upgrade-diff-textbox-upgrade-value"
            />
          </div>
        </div>
        {applied && (
          <div className="absolute right-4 top-3">
            <Icon
              icon="lucide:check"
              className="text-green-500"
              data-testid="datasource-upgrade-diff-textbox-accepted-icon"
            />
          </div>
        )}
      </div>
      <div className="flex w-full pt-4">
        <div className="flex-1 text-center">
          <Button
            onClick={() => setCurrent(diff.currentValue ?? '')}
            rightIcon="lucide:chevron-right"
            disabled={current === diff.currentValue}
            data-testid="datasource-upgrade-diff-textbox-copy-btn"
          >
            Copy to pending
          </Button>
        </div>
        <div className="flex-1 text-center">
          <Button
            onClick={() => onApply(current)}
            variant="primary"
            disabled={applied || isApplying}
            data-testid="datasource-upgrade-diff-textbox-apply-btn"
          >
            Apply pending version
          </Button>
        </div>
      </div>
    </div>
  );
};
